import { baseFetch } from '../../baseFetch';
import { AllOrgsResponseSchema, OrgDetailResponseSchema } from './orgs.schema';

export const getAllOrgs = (populate: boolean = false) => {
  return baseFetch(
    'internal',
    '/api/v2/raptor_admin/orgs',
    AllOrgsResponseSchema.defined(),
    {
      searchParams: {
        populate: populate ? '1' : '0',
      },
    },
  );
};

export const getOrgDetails = (orgId: number) =>
  baseFetch(
    'internal-v2',
    `/orgs/${orgId}/users` as `/${string}`,
    OrgDetailResponseSchema,
  );
